import { PlaceholderPage } from '../components/PlaceholderPage';

export const WineryXplorerBlog = () => {
  return (
    <PlaceholderPage
      title="WineryXplorer Blog"
      description="Stories, guides, and dispatches from the world of wine — coming soon."
    />
  );
};
